import { Combobox, Errors, Field, WithForm } from '@startlibs/form';
import {Dialog, Button} from '@startlibs/components'
import {formFetch} from '@startlibs/utils'
import React from 'react'
import _ from 'lodash/fp'

import {StudyCard} from './StudyCard'
import {useNotificationRef} from '../../components/Notifications'

const OPTIONS = [
  "Normal",
  "STAT",
  "Time Sensitive"
]

export const EditStatusDialog = ({study, setStudy, closeDialog}) => {
  const [,setNotification] = useNotificationRef()

  return <WithForm
    action={formFetch("/new_status_update.php")}
    onSuccess={({new_status}) => {
      setStudy(_.set('status.currentStatus', new_status));
      closeDialog()
      setNotification("Status successfully updated.")
    }}
    values={{new_status: study.status.currentStatus, id: study.study.id}}
  >{form =>
    <Dialog
      title="Status update"
      closeDialog={closeDialog}
      footer={<>
        <Button onClick={closeDialog}>Cancel</Button>
        <Button type="submit" highlight onClick={form.willSubmitForm} isLoading={form.isLoading}>Update status</Button>
      </>}
    >
      <StudyCard study={study}/>
      <Field label="Select a new status:"
             descText={<>The current status is: <b css="color:rgb(120,120,120)">{study.status.currentStatus}</b></>}>
        <Combobox path="new_status" options={OPTIONS}/>
      </Field>
      <Errors/>
    </Dialog>
  }</WithForm>
}